import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import FilledAptitudeTest from 'src/entities/FilledAptitudeTest';
import TestResultsInvestorTypeComponent, {
  TestResultsInvestorTypeComponentProps
} from './AptitudeTestResultsInvestorType.component';
import Test from 'src/entities/AptitudeTest';
import { getAptitudeTest, GetAptitudeTestAction } from 'src/actions/aptitude-test/get/GetAptitudeTest.actions';
import {
  getLatestFilledAptitudeTest,
  GetLatestFilledAptitudeTestAction
} from 'src/actions/filled-test/get/GetLatestFilledAptitudeTest.actions';
import InvestorType from 'src/entities/InvestorType';
import { history } from 'src/store';
import {
  changeInvestorType,
  ChangeInvestorTypeAction
} from 'src/actions/investor-type/change-data/ChangeInvestorType.actions';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import FilledTestSection from 'src/entities/FilledAptitudeTestSection';
import FilledTestQuestion from 'src/entities/FilledAptitudeTestQuestion';
import Person from 'src/entities/Person';
import { getUser, GetUserAction } from 'src/actions/user/get/GetUser.actions';
import * as getUserTypes from 'src/actions/user/get/Types';
import { getInvestorType, GetInvestorTypeAction } from 'src/actions/investor-type/get/GetInvestorType.actions';

interface StateProps {
  filledAptitudeTest?: FilledAptitudeTest;
  aptitudeTest?: Test;
  investorType?: InvestorType;
  activeProfile?: Person;
  loggedUserData: number | null;
}

interface DispatchProps {
  getAptitudeTest(testName: string): Promise<GetAptitudeTestAction>;

  getLatestFilledAptitudeTest(personId: number, personType: string): Promise<GetLatestFilledAptitudeTestAction>;

  getInvestorType(personId: number, personType: string): Promise<GetInvestorTypeAction>;

  changeInvestorType(investorType: InvestorType):
    ChangeInvestorTypeAction;

  getUser(userId: number): Promise<GetUserAction>;
}

interface Props extends StateProps, DispatchProps {

}

class AptitudeTestResultsInvestorTypeContainer extends React.Component<Props> {

  public componentWillMount(): void {
    if (this.props.activeProfile) {
      this.getAptitudeTest(this.props.activeProfile.personType);
      this.props.getLatestFilledAptitudeTest(this.props.activeProfile.id, this.props.activeProfile.personType);
      if (!this.props.investorType) {
        this.props.getInvestorType(this.props.activeProfile.id, this.props.activeProfile.personType);
      }
    } else if (this.props.loggedUserData) {
      this.props.getUser(this.props.loggedUserData).then((response) => {
        if (response.type === getUserTypes.GET_USER_SUCCESS && this.props.activeProfile) {
          this.getAptitudeTest(this.props.activeProfile.personType);
          this.props.getLatestFilledAptitudeTest(this.props.activeProfile.id, this.props.activeProfile.personType);
          this.props.getInvestorType(this.props.activeProfile.id, this.props.activeProfile.personType);
        }
      });
    }
  }

  public componentWillReceiveProps(nextProps: StateProps) {
    if (this.props.activeProfile && nextProps.activeProfile &&
      (this.props.activeProfile.id !== nextProps.activeProfile.id ||
        this.props.activeProfile.personType !== nextProps.activeProfile.personType)) {
      history.push('/mi-cuenta/tipo-de-inversor');
    }
  }

  public render(): React.ReactNode {
    return (
      this.props.filledAptitudeTest && this.props.aptitudeTest ?
        <TestResultsInvestorTypeComponent {...this.getComponentProps()} /> :
        <LoadingContainer/>
    );
  }

  private getAptitudeTest(personType: string): void {
    let aptitudeTestName;
    if (personType === 'physical') {
      aptitudeTestName = 'physical_person_adequacy_test';
    } else if (personType === 'juridical') {
      aptitudeTestName = 'juridical_person_adequacy_test';
    }
    if (aptitudeTestName) {
      this.props.getAptitudeTest(aptitudeTestName).then(() => {
        const filledTest = new FilledAptitudeTest({testId: this.props.aptitudeTest!.id});
        this.props.aptitudeTest!.sections.map(
          (section) => {
            const filledSection = new FilledTestSection({sectionId: section.id});
            section.questions.map(
              (question) => (
                filledSection.questions!.push(new FilledTestQuestion({questionId: question.id}))
              )
            );
            filledTest.sections!.push(filledSection);
          }
        );
        this.setState({filledTest: filledTest});
      });
    }
  }

  private failedTestMessage(filledAptitudeTest: FilledAptitudeTest, test: Test): string {
    let message = '';
    filledAptitudeTest.sections!.forEach((section: FilledTestSection, index: number) => {
      if (!section.passed) {
        message = (message === 'financiero') ? message : test.sections[index].type;
      }
    });
    return message;
  }

  private handleClick(): void {
    const investorType = this.props.investorType!;
    investorType.acceptedRisks = true;
    investorType.type = 'Accredited';
    investorType.filledAptitudeTestId = this.props.filledAptitudeTest!.id!.toString();
    this.props.changeInvestorType(new InvestorType(investorType));
    history.push('/mi-cuenta/tipo-de-inversor/acreditado/confirmar');
  }

  private getComponentProps(): TestResultsInvestorTypeComponentProps {
    return {
      filledAptitudeTest: this.props.filledAptitudeTest!,
      failMessage: this.props.filledAptitudeTest!.passed ? undefined :
        this.failedTestMessage(this.props.filledAptitudeTest!, this.props.aptitudeTest!),
      activeProfile: this.props.activeProfile!,
      handleClick: () => this.handleClick(),
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getAptitudeTest: (aptitudeTestName: string): Promise<GetAptitudeTestAction> => (
    dispatch(getAptitudeTest(aptitudeTestName))
  ),
  getLatestFilledAptitudeTest: (personId: number, personType: string): Promise<GetLatestFilledAptitudeTestAction> => (
    dispatch(getLatestFilledAptitudeTest(personId, personType))
  ),
  getInvestorType: (personId: number, personType: string): Promise<GetInvestorTypeAction> => (
    dispatch(getInvestorType(personId, personType))
  ),
  changeInvestorType: (investorType: InvestorType):
    ChangeInvestorTypeAction => (
    dispatch(changeInvestorType(investorType))
  ),
  getUser: (userId: number): Promise<GetUserAction> => (
    dispatch(getUser(userId))
  ),
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  filledAptitudeTest: state.getLatestFilledAptitudeTest.filledAptitudeTest || undefined,
  aptitudeTest: state.getAptitudeTest.aptitudeTest || undefined,
  investorType: state.getInvestorType.investorType,
  activeProfile: state.setActiveProfile.activeProfile || state.getUser.activeProfile,
  loggedUserData: state.authentication.loggedUserData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AptitudeTestResultsInvestorTypeContainer);



// WEBPACK FOOTER //
// ./src/modules/my-account/investor-types/aptitude-test/AptitudeTestResultsInvestorType.container.tsx